import { render, staticRenderFns } from "./RightFitSlide.vue?vue&type=template&id=028ee608&scoped=true&"
import script from "./RightFitSlide.vue?vue&type=script&lang=js&"
export * from "./RightFitSlide.vue?vue&type=script&lang=js&"
import style0 from "./RightFitSlide.vue?vue&type=style&index=0&id=028ee608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ee608",
  null
  
)

export default component.exports